export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-grid-line', description: '浏览所有精选福利视频资源' },
  { id: 'hot', name: '热门推荐', slug: 'hot', icon: 'ri-fire-line', description: '最受欢迎的福利视频，每日精选推荐' },
  { id: 'movie', name: '影视福利', slug: 'movie', icon: 'ri-movie-2-line', description: '最新电影、电视剧福利资源合集' },
  { id: 'variety', name: '综艺娱乐', slug: 'variety', icon: 'ri-tv-2-line', description: '热门综艺节目福利片段精选' },
  { id: 'music', name: '音乐舞台', slug: 'music', icon: 'ri-music-2-line', description: '演唱会、音乐节目精彩福利合集' },
  { id: 'sports', name: '体育赛事', slug: 'sports', icon: 'ri-basketball-line', description: '精彩体育赛事福利回放与集锦' },
  { id: 'anime', name: '动漫二次元', slug: 'anime', icon: 'ri-ghost-line', description: '动漫番剧、二次元相关福利内容' },
  { id: 'game', name: '游戏电竞', slug: 'game', icon: 'ri-gamepad-line', description: '游戏实况、电竞比赛福利视频' },
  { id: 'lifestyle', name: '生活时尚', slug: 'lifestyle', icon: 'ri-heart-line', description: '生活技巧、时尚穿搭福利分享' },
];